import { useStyletron } from "baseui";
import { Block } from "baseui/block"
import { SIZE } from "baseui/button";
import { Checkbox } from "baseui/checkbox";
import { FormControl } from "baseui/form-control"
import { TimePicker } from "baseui/timepicker";
import { LabelXSmall } from "baseui/typography";
import { addMinutes, endOfDay, startOfDay } from "date-fns";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";


const EditTimeRangeForm = (props: { timeFrom, timeTo, onTimeFromChange: (newValue: Date) => void, onTimeToChange: (newValue: Date) => void }) => {
    const intl = useIntl();
    const [css, theme] = useStyletron();

    const [endOfDay1, setEndOfDay] = useState(false);
    const [startOfDay1, setStartOfDay] = useState(false);

    const handleTimeFromChanged = (time: Date | null) => {
        if (!time)
            return;

        if (time >= props.timeTo)
            time = addMinutes(props.timeTo, -15);

        props.onTimeFromChange(time as Date);
    }
    const handleTimeToChanged = (time: Date | null) => {
        if (!time)
            return;
        if (time <= props.timeFrom)
            time = addMinutes(props.timeFrom, 15);

        props.onTimeToChange(time as Date);
    }

    const handleStartOfDayClick = (args) => {
        const checked = args.target.checked;
        setStartOfDay(checked);
        if (checked) {
            props.onTimeFromChange(startOfDay(new Date()));
        }
    }
    const handleEndOfDayClick = (args) => {
        const checked = args.target.checked;
        setEndOfDay(checked);
        if (checked) {
            props.onTimeToChange(endOfDay(new Date()));
        }
    }

    return (
        <FormControl
            label={() => intl.formatMessage({ id: "timeRangeInput", defaultMessage: "Timerange" })}
            caption={() => intl.formatMessage({ id: "timeRangeInputDescription", defaultMessage: "Select a time range" })}
        >
            <Block display='flex' flexDirection='column' gridGap={theme.sizing.scale600}  >

                <Block display={'flex'} flexDirection={'row'} alignItems={'center'} gridGap={theme.sizing.scale400}>
                    <div className={css({ width: '40px' })}>
                        <LabelXSmall> <FormattedMessage id="from" defaultMessage="from" /></LabelXSmall>
                    </div>
                    <div className={css({ width: '150px' })}>
                        <TimePicker
                            disabled={startOfDay1}
                            value={props.timeFrom}
                            onChange={handleTimeFromChanged}
                            size={SIZE.default}
                            placeholder={undefined}
                            format="24"
                            step={900}
                        />
                    </div>
                    <Checkbox
                        labelPlacement={'right'}
                        checked={startOfDay1}
                        checkmarkType={'toggle'}
                        onChange={handleStartOfDayClick}
                    >
                        {intl.formatMessage({ id: "Scheduler.StartOfDay", defaultMessage: "Start of day" })}
                    </Checkbox>
                </Block>

                <Block display={'flex'} flexDirection={'row'} alignItems={'center'} gridGap={theme.sizing.scale400}>
                    <div className={css({ width: '40px' })}>
                        <LabelXSmall><FormattedMessage id="to" defaultMessage="to" /></LabelXSmall>
                    </div>
                    <div className={css({ width: '150px' })}>
                        <TimePicker

                            disabled={endOfDay1}
                            value={props.timeTo}
                            onChange={date => handleTimeToChanged(date)}
                            size={SIZE.default}
                            placeholder={undefined}
                            format="24"
                            step={900}
                        />
                    </div>
                    <Checkbox
                        labelPlacement={'right'}
                        checked={endOfDay1}
                        checkmarkType={'toggle'}
                        onChange={handleEndOfDayClick}
                    >
                        {intl.formatMessage({ id: "Scheduler.EndOfDay", defaultMessage: "End of day" })}
                    </Checkbox>
                </Block>
            </Block>
        </FormControl>
    )
}

export default EditTimeRangeForm;